import * as React from 'react'
import classNames from 'classnames'
import { IIframe } from './interface'
import './Iframe.scss'

const Iframe = ({ className, url }: IIframe) => <iframe className={classNames('Iframe', className)} src={url}></iframe>

export default Iframe
